import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { groupSkillControllerGetAll } from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

type ArtifactListAccess = "owner" | "write" | "read";

export const useGroupSkillsData = ({
  groupUuid,
  access,
}: {
  groupUuid: string | null;
  access?: ArtifactListAccess;
}) => {
  const { data: skillsResponse, isLoading } = useQuery({
    enabled: useIsApiReady() && !!groupUuid,
    queryKey: queryKeys.groupSkills({
      groupUuid: groupUuid!,
      access,
    }),
    queryFn: async () => {
      const response = await groupSkillControllerGetAll({
        path: {
          groupUuid: groupUuid!,
        },
        query: access ? { filter: { access } } : undefined,
      });
      return response.data;
    },
  });

  const skills = skillsResponse?.data || [];

  return {
    skills,
    isLoading,
  };
};
